// @flow

import React, { type Node } from 'react';
import { useUniqueId } from '@tectonics/hooks';
import { useUserInputAsSelect } from '@tectonics/prs/user-input-values';
import { useSubmitting } from '@tectonics/prs/submitting';
import { useUserInputValidationError } from '@tectonics/prs/validation';
import { useFormHasBeenSent } from '@tectonics/prs/form-status';
import { getSafeEftPaymentOption } from '@tectonics/prs/incoming-payment/payment-option';
import { useOpenedIncomingPayment } from '@tectonics/prs/incoming-payment';

import { Select, SelectOption, Text, Separator } from '../../../../../atoms';
import { ErrorLabel } from '../../../../../molecules/error-label';
import { getSafePaymentOptionsV2 } from '@tectonics/prs/incoming-payment/get-payment-options';

export function BankList(): Node {
  const inputId = useUniqueId();
  const incomingPayment = useOpenedIncomingPayment();
  const [value, handleChange] = useUserInputAsSelect('selectedEftBank');
  const submitting = useSubmitting();

  const validationError = useUserInputValidationError('selectedEftBank');
  const formHasBeenSent = useFormHasBeenSent();

  const paymentOptions = getSafePaymentOptionsV2(incomingPayment);
  const bankList = getSafeEftPaymentOption(paymentOptions);

  return(
    <div data-test-name="payment-type-code">
      <Text flavor="info">
        Serás direccionado a la página de la banca en línea que selecciones.
      </Text>
      <Separator direction="vertical" size={4}/>
      <label htmlFor={inputId}>
        Banco
      </label>
      <Select
        id={inputId}
        value={value}
        onChange={handleChange}
        readOnly={submitting}
        fashion={formHasBeenSent && validationError ? 'error' : null}
        data-error={formHasBeenSent && validationError ? 'error' : null}
        name="payment-type-code"
      >
        <SelectOption value="">Selecciona tu banco</SelectOption>
        {bankList.map(({ name, value }) => (
          <SelectOption key={name} value={value}>
            {name}
          </SelectOption>
        ))}
      </Select>

      {formHasBeenSent && validationError && (
        <ErrorLabel>El banco elijido es inválido</ErrorLabel>
      )}
    </div>
  );
}
